import React from 'react';
import { useSelector } from 'react-redux';
import { Layout, Typography } from 'antd';
import EbzMenu from 'components/EbzMenu';
import ReferralCard from './ReferalCard';

const { Sider } = Layout;

function SideBar() {
  const user = useSelector((state) => state.user.currentUser);
  const logo = useSelector((state) => state.user.theme.logo);

  return (
    <Sider breakpoint="lg" collapsedWidth="0" width={280} style={{ background: '#fff' }}>
      <div
        className="custom-icon"
        style={{
          background: 'white',
          padding: '14px 14px 0px 24px',
          alignItems: 'center',
          marginBottom: '4px'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          {logo}
        </div>
        <Typography.Title
          level={5}
          style={{ marginLeft: 55, padding: 0, marginTop: 0, marginBottom: 0, fontWeight: 500 }}
        >
          Partners Portal
        </Typography.Title>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflowY: 'auto',
          paddingBottom: '80px'
        }}
      >
        <div style={{ flex: '0 0 50%', padding: '0 14px' }}>
          <EbzMenu />
        </div>
        <div
          style={{
            flexShrink: 0,
            padding: '10px 14px',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <ReferralCard refCode={user?.ref_code} />
        </div>
      </div>
    </Sider>
  );
}

export default SideBar;
